import { takeLatest, put, call } from 'redux-saga/effects';

import { listCampoCadastro } from '../service';
import {
    TABLE_CAMPO_CADASTRO,
    TABLE_CAMPO_CADASTRO_PENDING,
    TABLE_CAMPO_CADASTRO_SUCCESS,
    TABLE_CAMPO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListCampoCadastro(action) {
  yield put({ type: TABLE_CAMPO_CADASTRO_PENDING })

  try {
    const table = yield call(listCampoCadastro, action.args)
    yield put({ type: TABLE_CAMPO_CADASTRO_SUCCESS, table: table })
  } catch (error) {
    yield put({ type: TABLE_CAMPO_CADASTRO_FAILURE })
  }
}

export default function* watchListCampoCadastro() {
  yield takeLatest(TABLE_CAMPO_CADASTRO, sagaListCampoCadastro)
}